import { createContext as e, useContext as t } from "react";
import { css as n, styled as r } from "styled-components";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/ButtonGroup/ButtonGroup.tsx
var a = e(void 0), o = r.div`
    display: inline-flex;
    align-items: center;
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.md};
    overflow: hidden;
    background-color: ${({ theme: e }) => e.colors.muted};
    gap: 0;
`, s = r.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    padding: ${({ theme: e }) => `${e.spacing(.75)} ${e.spacing(2)}`};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    border: none;
    cursor: pointer;
    white-space: nowrap;
    transition: all ${({ theme: e }) => e.transitions.fast};
    outline: none;

    ${({ theme: e, $active: t }) => t ? n`
                  background-color: ${e.colors.card};
                  color: ${e.colors.foreground};
                  box-shadow: ${e.shadows.sm};
              ` : n`
                  background-color: transparent;
                  color: ${e.colors.mutedForeground};

                  &:hover {
                      color: ${e.colors.foreground};
                  }
              `}

    &:focus-visible {
        outline: 2px solid ${({ theme: e }) => e.colors.ring};
        outline-offset: -2px;
    }
`, c = ({ value: e, children: n }) => {
	let r = t(a);
	if (!r) throw Error("ButtonGroupItem must be used within a ButtonGroup");
	return /* @__PURE__ */ i(s, {
		type: "button",
		$active: r.value === e,
		onClick: () => r.onChange(e),
		"aria-pressed": r.value === e,
		children: n
	});
}, l = ({ value: e, onChange: t, children: n, className: r }) => /* @__PURE__ */ i(a.Provider, {
	value: {
		value: e,
		onChange: t
	},
	children: /* @__PURE__ */ i(o, {
		className: r,
		role: "group",
		children: n
	})
});
//#endregion
export { l as ButtonGroup, c as ButtonGroupItem };
